import React, { Component } from "react";
import { Link } from "react-router-dom";
import { decode as base64_decode, encode as base64_encode } from "base-64";

import { observer } from "mobx-react";
import withRouter from "../withRouter";
import { StoreContext } from "../store/RootStore";
import HelpModal from "./HelpModal";
import { Tooltip,Button, Row, Col, Typography,Image,Modal,message} from "antd";
import Cookies from "universal-cookie";
import conf from "../config";
import {
  UserOutlined,
  LockOutlined
} from "@ant-design/icons";
const { Title } = Typography;
class SecureTrackMonitor extends Component {
  constructor(props) {
    super(props);
    this.cookies = new Cookies();
    
  }
  componentDidMount() {
    console.log("SecureTrackMonitor mounted successfully");
  }

  


  render() {
    const isAdmin = JSON.parse(base64_decode(this.cookies.get("data"))).isadmin;
    const formItemStyle = { marginBottom: "2px", marginTop: "2px" };

    return (
 <div className="monitorapp-container">
  <div className="login-overlay">
      {/* Logo Section */}
      <div className="container mt-4" style={{ textAlign: 'right' }}>
        <Image
          src={require('../assets/images/swd-dashboard-st.png')}
          alt="SecureTrackX"
          preview={false}
          className="mainLogo"
        />
      </div>

      {/* Login Circles */}
      <div className="login-section-2">
        {!(isAdmin === 0 || isAdmin === 1) && (
        <div className="circle-1 login-circle">
          <div className="bggreen gap-2">
            <Image
              src={require('../assets/images/st-monitor-renew.png')}
              alt="SecurePath"
              preview={false}
              className="circle-logo"
              height={"38px"}
              
            />
             <Title level={5} className="white-text" style={{ marginBottom: '5px', color: 'white'}}>
              RENEW
            </Title>
                <span style={{color: '#FFF', padding: '0px 8px', fontSize: '0.75rem',}}>
                  {/* {renewCount} */}
                  10
                </span>
          </div>
        </div>
        )}

        {/* SecureTrackX Circle */}
            <div className="circle-2 login-circle-2 large-2"
              onClick={() => this.props.navigate("/SecureTrackLaunchingDashboard")}
              style={{ cursor: "pointer" }}
            >
              <div className="bgblack">
                {/* <Image
              src={require('../assets/images/swd-dashboard-st.png')}
              alt="SecureTrackX"
              preview={false}
              className="circle-logo large-logo"
            /> */}
                <Title level={5} className="white-text" style={{ marginBottom: '5px', color: 'white' }}>
                  MONITOR
                </Title>
                {/* <Link to="/SecureTrackLaunchingDashboard"> */}

                {/* </Link> */}
              </div>
            </div>

        {/* SecureTrack Basic Circle */}
        {!(isAdmin === 0 || isAdmin === 1) && (
          <div className="circle-3 login-circle">
            <div className="bgred text-center">
            <div className="new-img ">
              <Image
                src={require('../assets/images/st-monitor-new.png')}
                alt="SecurePath"
                preview={false}
                height={"100px"}
              />
              <Title level={5} className="white-text mt-4" style={{ marginBottom: '-15px', color: 'white', position: 'absolute', marginLeft: '45px'}}>
                NEW
              </Title>
            </div>
            </div>
          </div>
        )}
      </div>
    </div>
    
    </div>
    
    );
  }
}
SecureTrackMonitor.contextType = StoreContext;
export default observer(withRouter(SecureTrackMonitor));
